const VOLUME_KEY = "dreamverse.music.volume.v2";
const LEGACY_VOLUME_KEY = "dreamverse.music.volume";

/** 首次 50%；之后记住用户设置，并修复旧版把“尚未设置”误存成 0 的数据。 */
export function initialMusicVolume(
  storage: Pick<Storage, "getItem">,
): number {
  const saved = storage.getItem(VOLUME_KEY);
  if (saved !== null) {
    const value = Number(saved);
    if (Number.isFinite(value) && value >= 0 && value <= 1) return value;
  }

  // 旧实现把 localStorage 的 null 送进 Number(null)，首次访问会被误判成 0 并持久化。
  // 迁移时保留明确设置过的非零音量；旧值为 0 无法区分“用户静音”和该缺陷，统一恢复 50%。
  const legacy = storage.getItem(LEGACY_VOLUME_KEY);
  if (legacy !== null) {
    const value = Number(legacy);
    if (Number.isFinite(value) && value > 0 && value <= 1) return value;
  }
  return 0.5;
}

export function persistMusicVolume(
  storage: Pick<Storage, "setItem">,
  volume: number,
): void {
  storage.setItem(VOLUME_KEY, String(volume));
}
